import moment from 'moment';

export const getFormatedDate = (date, type = 'DD.MM.YYYY') => {
    if(!date) return '-';
    return moment(date).format(type);
}

export const isInvalidRange = (dateFrom, dateTo) => {
    if(dateFrom > dateTo) return false;

    return true;
}

export const isDateInRange = (date, start, end) => {
    return date >= start && date <= end;
}